module.exports = "/10/4-streams-for-string-c/index.html.88022f6063c4fdfb69941f82e6b53724.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/35649.md
 ** module id = 589
 ** module chunks = 0
 **/